module.exports = __webpack_public_path__ + "img/abbg2.f600c601.jpg";